module.exports = __webpack_public_path__ + "img/67.f0092607.jpg";